import React, { useEffect, useState } from "react";
import { BellRing, Send, Undo2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const SYM = { BRL: "R$", USD: "US$", EUR: "€" };
const KIND = { sale: "Venda", refunded: "Reembolso", chargeback: "Chargeback", cancelled: "Cancelamento", refund_requested: "Pedido de reembolso" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR") : "—");
const money = (a, c) => (a != null && c ? `${SYM[c] || c} ${Number(a).toFixed(2)}` : "—");
const line = (h) => `${KIND[h.kind] || h.kind} · ${fmt(h.at)} · ${h.market} · ${money(h.amount, h.currency)} · ${h.provider}${h.emailed ? " · e-mail enviado" : ` · não enviado (${h.reason || h.error || "—"})`}`;

export function SaleAlertsCard() {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/sale-alerts?limit=50").then(({ data }) => setInfo(data)).catch(() => setInfo({ error: true }));
  useEffect(() => { load(); }, []);
  const test = async (kind) => {
    setBusy(kind);
    try {
      const { data } = await api.post(`/admin/sale-alerts/test?kind=${kind}`);
      toast.success(`Alerta de ${KIND[data.kind]?.toLowerCase() || data.kind} (teste) enviado para ${data.to}`);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Falha ao enviar o alerta"); }
    finally { setBusy(""); }
  };
  if (!info) return null;
  const lastSale = info.history?.find((h) => h.kind === "sale");
  const lastRefund = info.history?.find((h) => !["sale", "pending_48h"].includes(h.kind));
  return (
    <div className="glass rounded-2xl p-5" data-testid="sale-alerts-card">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="flex items-center gap-2 font-display text-lg text-xmas-snow"><BellRing className="h-5 w-5 text-xmas-gold" /> Alertas instantâneos de venda</p>
          <p className="mt-1 text-xs text-xmas-champagne" data-testid="sale-alerts-info">
            E-mail a cada compra aprovada, reembolso, chargeback ou cancelamento (país, valor, provider) · para <span className="text-xmas-gold">{info.recipient || "— (SUPPORT_EMAIL não configurado)"}</span>
            {!info.email_enabled && <span className="ml-2 rounded-full bg-amber-500/15 px-2 py-0.5 text-[10px] uppercase tracking-wider text-amber-300" data-testid="sale-alerts-suppressed">envio real só em produção</span>}
          </p>
          <p className="mt-1 text-[11px] text-xmas-slate" data-testid="sale-alerts-last">{lastSale ? `Última venda: ${line(lastSale)}` : "Nenhum alerta de venda registrado ainda."}</p>
          <p className="mt-0.5 text-[11px] text-xmas-slate" data-testid="sale-alerts-last-refund">{lastRefund ? `Último estorno: ${line(lastRefund)}` : "Nenhum reembolso/chargeback registrado ainda."}</p>
          <Link to="/admin/alerts" className="mt-1 inline-block text-[11px] text-xmas-gold hover:underline" data-testid="sale-alerts-history-link">Ver histórico completo →</Link>
        </div>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => test("sale")} disabled={!!busy || !info.recipient} data-testid="sale-alerts-test" className="inline-flex items-center gap-2 rounded-full border border-xmas-gold/40 px-4 py-2 text-xs font-bold uppercase tracking-wider text-xmas-snow transition hover:border-xmas-gold hover:text-xmas-gold disabled:opacity-50">
            <Send className="h-3.5 w-3.5" /> {busy === "sale" ? "Enviando…" : "Testar venda"}
          </button>
          <button onClick={() => test("refunded")} disabled={!!busy || !info.recipient} data-testid="sale-alerts-test-refund" className="inline-flex items-center gap-2 rounded-full border border-orange-400/40 px-4 py-2 text-xs font-bold uppercase tracking-wider text-orange-200 transition hover:border-orange-300 hover:text-orange-100 disabled:opacity-50">
            <Undo2 className="h-3.5 w-3.5" /> {busy === "refunded" ? "Enviando…" : "Testar reembolso"}
          </button>
        </div>
      </div>
    </div>
  );
}
